// extracted by mini-css-extract-plugin
export default {"mainWrapper":"poc-detail_mainWrapper__Kgq1y","headerWrapper":"poc-detail_headerWrapper__-8wfU","pocWrapper":"poc-detail_pocWrapper__oeEXL"};